module.exports = __webpack_public_path__ + "img/temp-banner-advertise.7b34a4a3.jpg";